const initialState = {
  editing: false,
  erroring: false,
  saving: false,
  values: {},
  errors: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPEN_EDIT_DETAILS':
      return { ...state, editing: true };
    case 'CLOSE_EDIT_DETAILS':
      return { ...state, editing: false };
    case 'DETAILS_SAVING':
      return { ...state, saving: true };
    case 'DETAILS_DONE_SAVING':
      return { ...state, saving: false };
    case 'LOAD_DETAILS': {
      const values = { ...action.user };
      return { ...initialState, values };
    }
    case 'EDIT_DETAILS': {
      const values = { ...state.values, [action.id]: action.value };
      const errors = { ...state.errors, [action.id]: !action.valid };
      const erroring = Object
        .keys(errors)
        .reduce((_erroring, id) => _erroring || errors[id], false);

      return {
        ...state,
        values,
        errors,
        erroring,
      };
    }
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
